import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, PreviewAltCard, Row } from "../../components/Component";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import useLogout from "../../hooks/useLogout";

import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";

import UserDataListTable from "../../MyComp/UI/DataTable/UserDataListTable";
import { listUserAPI } from "../../api/user";
import { updateRegisterUSerAPI } from "../../api/master/indes";
const User = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,

    clearErrors,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));

  useEffect(() => {
    registeredUserList();
  }, []);

  const registeredUserList = () => {
    listUserAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) { 
          setData(res.data.data);
          setValue("isLoading", false);
        } else {
          setData([]);
          setValue("isLoading", false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };

  const resetF = () => {};
  const handleEdit = () => {};

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));
const confirmStatusChange = () => {
  const selectedRow = watch("selectedRow");
  if (!selectedRow) return;

  const updatedStatus = !selectedRow.status;

  const body = {
    id: selectedRow.id,
    status: updatedStatus,
  };

  setValue("isLoading", true);

  updateRegisterUSerAPI(body)
    .then((res) => {
      if (res.data.status === "expired") {
        toast.error(res.data.message);
        logout();
      } 
      else if (res.data.status === true) {
        toast.success(res.data.message);

       
        setData((prev) =>
          prev.map((item) =>
            item.id === selectedRow.id
              ? { ...item, status: updatedStatus }
              : item
          )
        );

        setShowModal(false);
      } 
      else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => toast.error(err?.response?.data?.message))
    .finally(() => setValue("isLoading", false));
};

  return (
    <>
      <Head title={"Product | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <UserDataListTable
            title=" User List "
            data={data}
            publicButton={false}
            columns={[
              { key: "profile_image", label: "Profile Image", type: "image" },
                { key: "mobile", label: "mobile", type: "Mobile" },
              //   { key: "id", label: "Id", type: "text" },
              // { key: "first_name", label: "First Name", type: "text" },
              // { key: "last_name", label: "Last Name", type: "text" },
              { key: "referred_by", label: "Referred By", type: "text" },
              { key: "referral_code", label: "Referral Code", type: "text" },
              { key: "email", label: "Email", type: "text" },
            ]}
            searchKeys={["first_name", "last_name", "referred_by", "referral_code", "email"]}
            nameColumn={"first_name"}
            firstName={["first_name"]}
            lastName={["last_name"]}
            imageBaseURL={BASE_URL_IMG}
            setData={setData}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            // confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
          />
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        // onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default User;
